import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import classNames from "classnames";

class FeedPost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popupOpen: false
        };
        this.openPopup = this.openPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.getBounds = this.getBounds.bind(this);
        this.openPost = this.openPost.bind(this);
    }

    openPost() {
        if (window && this.props.post.PostUrl) {
            window.location = this.props.post.PostUrl;
        }
    }

    openPopup() {
        //todo:Remove because the popup is extra "nice-to-have" feature
        /*this.setState({
            popupOpen:true
        })*/
        /*
         *
         <Modal
         aria-labelledby='modal-label'
         show={this.state.popupOpen}
         onHide={this.closePopup}
         >
         <FeedPostPopup
         post={post}
         close={this.closePopup}
         target={ props => findDOMNode(this.refs.target)}/>
         </Modal>
         *
         */
    }

    closePopup() {
        this.setState({
            popupOpen: false
        });
    }

    getBounds() {
        if (window && this.container) {
            return findDOMNode(this.refs.target).getBoundingClientRect();
        } else {
            return {};
        }
    }

    render() {
        /*
        recieving data in this.props.post
           // "PostImageUrl": "https://external.xx.fbcdn.net/safe_image.php?d=AQB729JCOki1W1GV&w=130&h=130&url=http%3A%2F%2Fwww.magnetix.dk%2Fglobalassets%2Fimages%2Fcases%2Froyal-copenhagen%2Froyal-copenhagen-header-image.png&cfs=1&_nc_hash=AQDbKq-ru61m8_bo",
           //  "PostMessage": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\n",
           //  "PostMessageLink": "https://www.magnetix.dk/",

            "PostUrl": "https://www.facebook.com/testpage4568978/posts/127135264474610",
            "PostDate": "yesterday",

           // "PostUserImageUrl": "https://scontent.xx.fbcdn.net/v/t1.0-1/p50x50/16649513_127095547811915_2684032176552193786_n.jpg?oh=7b21da174ebc868613a2e4810dec0303&oe=5934FCF0",
           // "PostUserName": "Zaheer Tariq",
           // "PostUserUrl": "https://www.facebook.com/app_scoped_user_id/125586867962783/",
            "_PostDateTime": "2017-02-22T11:00:10+01:00"
         onClick={ (e)=>{e.preventDefault(); this.openPopup()}}
        */
        const post = this.props.post;
        const classes = classNames({
            "feed-post": true,
            "feed-post--hasImage": post.PostImageUrl || null
        });

        return (
            <div className={classes} ref="target">
                <a className="feed-post__content" href={post.PostMessageLink} target="_blank">
                    {post.PostImageUrl && (
                        <div className="feed-post__image">
                            <img src={post.PostImageUrl} alt="" loading="lazy" role="presentation" />
                        </div>
                    )}
                    <div className="feed-post__message">{post.PostMessage}</div>
                </a>
                <div className="feed-post__user">
                    <a href={post.PostUserUrl} className="feed-post__user_linkwrap" target="_blank">
                        <div className="feed-post__user__image">
                            {post.PostUserImageUrl && <img src={post.PostUserImageUrl} alt="" />}
                        </div>
                        <span className="feed-post__user__name">{post.PostUserName}</span>
                    </a>
                </div>
            </div>
        );
    }
}

export default FeedPost;
